<template>
  <v-select
    v-model="selectedEvent"
    :items="eventsList"
    item-text="name"
    item-value="eventKey"
    placeholder="Tipo de Evento"
    outlined
    dense
    clearable
  >
    <template #item="{ item }">
      <v-list-item-icon>
        <v-icon color="primary">
          {{ mdiCalendarStar }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.name }}
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <template #selection="{ item }">
      <v-list-item-icon class="pb-0 pt-0 mt-1 mb-0">
        <v-icon color="primary">
          {{ mdiCalendarStar }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content class="pb-0 pt-0 mt-0 mb-0">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiCalendarStar } from '@mdi/js'
import useEventsList from '@/components/lists/events'

export default {

  setup(_, { emit }) {
    const selectedEvent = ref('')
    const { eventsList } = useEventsList()

    watch(selectedEvent, () => {
      emit('onSelect', selectedEvent.value)
    })

    const Reset = () => {
      selectedEvent.value = ''
    }

    return {
      selectedEvent,
      eventsList,
      Reset,
      mdiCalendarStar,
    }
  },
}
</script>
